import { DataSourceMode, DropdownItem, DropdownSelectionEvent, Textbox, ValidationResult } from "@mcleod/components";
import { AutogenLayoutCarrierScorecardReport } from "./autogen/AutogenLayoutCarrierScorecardReport";
import { ValidationResultType } from "@mcleod/components/src/base/ValidationResult";

export class CarrierScorecardReport extends AutogenLayoutCarrierScorecardReport {

     override onLoad(){
        this.textboxGroupBy.selectedItem = this.textboxGroupBy.items[0];
        this.textboxSortBy.selectedItem = this.textboxSortBy.items[0];
        this.textboxSortMetricBy.selectedItem = this.textboxSortMetricBy.items[0];
        this.textboxCarrierRanking.selectedItem = this.textboxCarrierRanking.items[0];
        this.textboxSortGroupsBy.visible = false;
        this.setReportType();
            this.textboxRankingValue.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                        return this.validateRankingValue(this.textboxRankingValue,this.textboxRankingValue.text, 1, 100);
                    };
            this.textboxCarrierRanking.addlValidationCallback = (_value: string, mode: DataSourceMode): ValidationResult => {
                     return this.validateRangeFields(false, this.textboxRankingValue,this.textboxCarrierRanking, this.textboxRankingValue.text, 1, 100);
                 };

    }

    onSelectGroupBy() {
        const selectedItem = this.textboxGroupBy.text;
        this.checkboxGroupBy.caption = "Add a page break after each " + selectedItem.toLowerCase();
        if (!this.textboxGroupBy.selectedItem.equals(this.textboxGroupBy.items[0])) {
            this.textboxSortGroupsBy.visible = true;
            const dropdownItems = [];
            switch (selectedItem) {
                case "Carrier Manager":
                    dropdownItems.push(new DropdownItem("Carrier manager code"));
                    dropdownItems.push(new DropdownItem("Carrier manager name"));
                    break;
                case "Carrier Salesperson":
                    dropdownItems.push(new DropdownItem("Salesperson code"));
                    dropdownItems.push(new DropdownItem("Salesperson name"));
                    break;
                case "Category":
                    dropdownItems.push(new DropdownItem("Category code"));
                    dropdownItems.push(new DropdownItem("Category name"));
                    break;
            }
            this.textboxSortGroupsBy.items = dropdownItems;

            if (dropdownItems.length > 0) {
                this.textboxSortGroupsBy.selectedItem = dropdownItems[0];
            }
        }
        else {
            this.textboxSortGroupsBy.text = "Carrier code"
            this.textboxSortGroupsBy.visible = false;
        }

    }

    setReportType() {
        const dropdownItems = [];
        dropdownItems.push(new DropdownItem("D", "Detailed"));
        dropdownItems.push(new DropdownItem("S", "Summary"));
        dropdownItems.push(new DropdownItem("T","Totals"));    
        this.textboxReportType.items = dropdownItems;          
        if (dropdownItems.length > 0) {
            this.textboxReportType.selectedItem = dropdownItems[0];
        }          
    }

     textboxCarrierRankingAfterDropdownSelection(event: DropdownSelectionEvent) {
            const rankingValTb = this.textboxRankingValue;
            const rankingVal = this.textboxRankingValue.text;

            if (event.selection.value !== "") {
                rankingValTb.required = true;
        
            } else {
                rankingValTb.required = false;
            }

        }

    validateRankingValue(rankingValue: Textbox, text: string, minValue: number, maxValue: number): ValidationResult {
        const rankingValueIsOutOfRange = !isNaN(parseFloat(text)) && (parseFloat(text) < minValue || parseFloat(text) > maxValue);
        const rankingValueIsNAN = isNaN(parseFloat(text));
        const carrierRankingIsEmpty = this.textboxCarrierRanking.text == "--" || this.textboxCarrierRanking.text == "";

        if (rankingValueIsOutOfRange && !carrierRankingIsEmpty) {
                return {
                    component: rankingValue,
                    isValid: false,
                    validationMessage: "Please enter a number between 1 and 100."
                };
        }
        else{
            rankingValue.resetValidation();
        }

        if (rankingValueIsNAN && !carrierRankingIsEmpty) {
            rankingValue.required = true;
            return {
                component: rankingValue,
                isValid: false,
                type: ValidationResultType.REQUIRED
            };
        }
        else{
            rankingValue.resetValidation();
        }

          if (rankingValueIsNAN && carrierRankingIsEmpty) {
            rankingValue.required = true;
            return {
                component: rankingValue,
                isValid: true
            };
        }
        return null;
    }
    

    validateRangeFields(isValue: boolean, rankingValue: Textbox, carrierRanking: Textbox, text: string, minValue: number, maxValue: number): ValidationResult {

        const carrierRankingIsEmpty = carrierRanking.text == "--";
        const rankingValueIsNAN = isNaN(parseFloat(text));

        if (carrierRankingIsEmpty && !rankingValueIsNAN) {
            return {
                component: carrierRanking,
                isValid: false
              };

        }
        else{
            carrierRanking.resetValidation();
            rankingValue.resetValidation();
        }
      

        return null;
    }
    
}
